import { render, staticRenderFns } from "./myapp.vue?vue&type=template&id=3b444524&scoped=true&"
import script from "./myapp.vue?vue&type=script&lang=js&"
export * from "./myapp.vue?vue&type=script&lang=js&"
import style1 from "./myapp.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b444524",
  null
  
)

export default component.exports